if (!customElements.get('app-feature')) {
  customElements.define(
    'app-feature',
    class AppFeature extends HTMLElement {
      constructor() {
        super();
        this.buttons = [];
        this.screens = [];
      }

      connectedCallback() {
        this.buttons = [...this.querySelectorAll('.features-buttons button')];
        this.screens = [...this.querySelectorAll('.screen-media')];

        if (!this.buttons.length || !this.screens.length) return;

        // Activate first item by default
        this.activateById(this.buttons[0].dataset.id);

        this.buttons.forEach(button => {
          button.addEventListener('click', () => {
            const id = button.dataset.id;
            this.activateById(id);
          });
        });
      }

      activateById(id) {
        // Reset all
        this.buttons.forEach(btn => btn.classList.remove('active'));
        this.screens.forEach(screen => screen.classList.remove('active'));

        // Activate matched ones
        const activeButton = this.buttons.find(
          btn => btn.dataset.id === id
        );
        const activeScreen = this.screens.find(
          screen => screen.dataset.id === id
        );

        if (activeButton) activeButton.classList.add('active');
        if (activeScreen) activeScreen.classList.add('active');
      }
    }
  );
}
